import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { API_URL } from '../config'
import Layout from './Layout'
import RegistrationDashboardLayout from './RegistrationDashboardLayout'

const OWNER_CYCLE_LANG_MAP = {
    228537: 3569,
}

const ContactCard = ({ contactCycleLang, idEvent, ownerIdContact }) => {
    const { contact, event_contact_type } = contactCycleLang
    const [copied, setCopied] = useState(false)

    const signupLink = `/events/${idEvent}/signup/remote-individual-webcast/c/${contact.id_contact}?form-name=remote-individual-webcast&formisvisible=1&id_formulaire=158&auteur=${ownerIdContact}`

    const handleCopy = () => {
        navigator.clipboard.writeText(window.location.origin + signupLink).then(() => {
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        })
    }

    return (
        <div className="flex items-center gap-3 p-3 rounded-xl bg-white dark:bg-neutral-800 shadow-sm border border-neutral-100 dark:border-neutral-700">
            <img
                src={contact.photos.small}
                alt=""
                className="w-12 h-12 rounded-full object-cover flex-shrink-0 ring-2 ring-e2o-500/30"
            />
            <div className="min-w-0 flex-1">
                <p className="font-semibold text-neutral-900 dark:text-white truncate">
                    {contact.prenom} {contact.nom}
                </p>
                {contact.societe && (
                    <p className="text-xs text-neutral-500 dark:text-neutral-400 truncate">{contact.societe}</p>
                )}
                {event_contact_type?.libelle && (
                    <span className="inline-block mt-1 text-xs px-2 py-0.5 rounded-full bg-e2o-500/10 text-e2o-600 dark:text-e2o-400 font-medium">
                        {event_contact_type.libelle}
                    </span>
                )}
            </div>
            <div className="flex gap-2 flex-shrink-0">
                <a
                    href={signupLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-3 py-1.5 rounded-lg bg-e2o-500 hover:bg-e2o-600 text-white text-xs font-medium transition-colors"
                >
                    Afficher
                </a>
                <button
                    onClick={handleCopy}
                    className="px-3 py-1.5 rounded-lg border border-e2o-500 text-e2o-600 dark:text-e2o-400 hover:bg-e2o-500/10 text-xs font-medium transition-colors"
                >
                    {copied ? 'Copié !' : 'Copier'}
                </button>
            </div>
        </div>
    )
}

const Portfolio = ({ isAdmin, profile }) => {
    const { ownerIdContact, idEvent } = useParams()
    const [contactCycleLangList, setContactCycleLangList] = useState(null)
    const [loading, setLoading] = useState(false)
    const idCycleLang = OWNER_CYCLE_LANG_MAP[ownerIdContact]

    useEffect(() => {
        if (!idCycleLang) return

        setLoading(true)
        fetch(`${API_URL}?action=getContactCycleLang&filter=  id_cycle_lang=${idCycleLang}`)
            .then(res => res.json())
            .then(res => setContactCycleLangList(res))
            .finally(() => setLoading(false))
    }, [idCycleLang])

    if (!idCycleLang) return (
        <Layout>
            {ownerIdContact}
            <p className="text-neutral-400 text-sm">Aucun collectif configuré pour ce profil.</p>
        </Layout>
    )

    return (
        <RegistrationDashboardLayout
            isAdmin={isAdmin}
            profile={profile}
        >
            <div className="max-w-2xl mx-auto px-4 py-6">
                <h2 className="text-lg font-bold text-neutral-800 dark:text-white mb-4">
                    Membres du collectif
                </h2>

                {loading && (
                    <div className="flex justify-center py-10">
                        <div className="w-6 h-6 border-2 border-e2o-500 border-t-transparent rounded-full animate-spin" />
                    </div>
                )}

                {!loading && contactCycleLangList && contactCycleLangList.length === 0 && (
                    <p className="text-neutral-400 text-sm text-center py-8">Aucun membre trouvé.</p>
                )}

                {!loading && contactCycleLangList && (
                    <div className="flex flex-col gap-2">
                        {contactCycleLangList.map(ccl => (
                            <ContactCard key={ccl.id_contact_cycle_lang} contactCycleLang={ccl} idEvent={idEvent} ownerIdContact={ownerIdContact} />
                        ))}
                    </div>
                )}
            </div>
        </RegistrationDashboardLayout>
    )
}

export default Portfolio
